import { useTranslation } from "../contexts/translations-context";

export const useTranslate = () => {
  const { t, language, setLanguage } = useTranslation();

  const getTranslation = (key, fallback) => {
    if (!key) return fallback;
    const translated = t(key);
  
    if (typeof translated === "string" && translated !== key) {
      return translated;
    }
  
    if (
      translated &&
      typeof translated === "object" &&
      typeof translated.label === "string"
    ) {
      return translated.label;
    }
  
    return fallback;
  };
  
  const getTranslatedProps = ({ languagesection, label, placeholder, options }) => {
    const translatedLabel = languagesection
      ? getTranslation(`${languagesection}.label`, label)
      : label;
  
    const translatedPlaceholder = languagesection
      ? getTranslation(`${languagesection}.placeholder`, placeholder)
      : placeholder;
  
    const translatedOptions = languagesection && Array.isArray(options)
      ? options.map((option) => {
          const optionValue = option?.value ?? "";
  
          return {
            label: getTranslation(
              `${languagesection}.options.${optionValue}`,
              option?.label ?? optionValue
            ),
            description: getTranslation(
              `${languagesection}.options.description.${optionValue}`,
              option?.description ?? optionValue
            ),
            value: optionValue,
            icon: option?.icon,
          };
        })
      : options;
  
    return {
      translatedLabel,
      translatedPlaceholder,
      translatedOptions,
    };
  };
  


  return { t, language, setLanguage, getTranslatedProps };
};
